var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeter3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6db33f",
    d: "M931.072 53.248c-14.421 34.389-32.683 66.987-54.656 96.939-92.968-92.8-221.312-150.187-363.059-150.187-0.027 0-0.054 0-0.081 0h0.004c-281.557 0-513.28 231.68-513.28 513.323 0 140.501 57.6 274.987 159.445 371.925l18.944 16.768c88.683 75.048 204.34 120.69 330.655 120.747h0.012c267.733 0 492.8-209.536 511.872-476.672 13.995-130.773-24.405-296.149-89.856-492.843zM232.405 888.192c-8.277 10.24-20.907 16.213-34.133 16.213-24.205-0.121-43.789-19.735-43.861-43.94v-0.007c0-24.064 19.84-43.947 43.861-43.947 24.26 0.077 43.896 19.761 43.896 44.032 0 10.51-3.682 20.16-9.827 27.73l0.064-0.082zM928.939 734.507c-126.677 168.704-397.227 111.872-570.667 119.979 0 0-30.805 1.877-61.739 6.912 0 0 11.605-4.907 26.667-10.667 121.728-42.325 179.328-50.56 253.312-88.533 139.349-70.827 277.077-225.835 305.749-387.072-53.077 155.136-213.845 288.427-360.405 342.613-100.395 36.992-281.728 72.96-281.728 72.96l-7.339-3.84c-123.477-60.075-127.189-327.339 97.195-413.611 98.261-37.803 192.299-17.067 298.411-42.325 113.323-26.88 244.395-111.872 297.728-222.677 59.733 177.237 131.627 454.741 2.816 626.261z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter3);
export default __webpack_public_path__ + "static/media/meter3.5dea314fd56451cca8c4beb9293c5cb0.svg";
export { ForwardRef as ReactComponent };